/**
 * Triggers a file download in the same tab using a Blob.
 * Creates a temporary object URL, clicks a hidden anchor element, then revokes the URL.
 *
 * @param blob - The file content as a Blob
 * @param fileName - The suggested file name for the download
 */
export const triggerBlobDownload = (
  blob: Blob | null,
  fileName: string
): void => {
  if (blob) {
    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(objectUrl)
  } else {
    console.error('Blob download failed due to empty payload.')
  }
}
